import type { RouteRecordRaw } from 'vue-router';
import gettext from 'src/utils/gettext';

const { $gettext } = gettext;

export const stockRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'stock',
    redirect: { name: 'supplies' },
  },
  {
    path: 'resources',
    alias: $gettext('zasoby'),
    children: [
      {
        path: '',
        name: 'supplies',
        component: () => import('src/pages/stock/StockPage.vue'),
      },
      {
        path: 'stocking',
        alias: $gettext('naskladneni'),
        name: 'stock-up',
        component: () => import('src/pages/stock/CreateSupplyPage.vue'),
      },
      {
        path: 'inventory',
        alias: $gettext('inventura'),
        name: 'stock-check',
        component: () => import('src/pages/stock/StockCheckPage.vue'),
      },
    ],
  },
  // TODO: Stock receipts & goods movement will be implemented in the next dev iteration
  // {
  //   alias: $gettext('doklady'),
  //   name: 'stock-receipts',
  //   component: () => import('src/pages/stock/StockReceiptsPage.vue'),
  // },
  // {
  //   alias: $gettext('pohyb-zbozi'),
  //   name: 'goods-movement',
  //   component: () => import('src/pages/stock/GoodsMovementPage.vue'),
  // },
  {
    path: 'items',
    alias: $gettext('polozky'),
    children: [
      {
        path: '',
        name: 'stock-items',
        component: () => import('src/pages/stock/StockItemsPage.vue'),
      },
      {
        path: 'new',
        alias: $gettext('nova'),
        name: 'stock-item-create',
        component: () => import('src/pages/stock/CreateStockItemPage.vue'),
      },
      {
        path: ':stockItemId/edit',
        alias: $gettext(':stockItemId/upravit'),
        name: 'stock-item-update',
        props: true,
        component: () => import('src/pages/stock/UpdateStockItemPage.vue'),
      },
    ],
  },
  {
    path: 'suppliers',
    alias: $gettext('dodavatele'),
    children: [
      {
        path: '',
        name: 'suppliers',
        component: () => import('src/pages/stock/SuppliersPage.vue'),
      },
      {
        path: 'new',
        alias: $gettext('novy'),
        name: 'supplier-create',
        props: (route) => ({
          next: route.query.next, // handle redirects after the supplier is either created or user goes back from the create form
        }),
        component: () => import('src/pages/stock/CreateSupplierPage.vue'),
      },
      {
        path: ':supplierId/edit',
        alias: $gettext(':supplierId/upravit'),
        name: 'supplier-update',
        props: true,
        component: () => import('src/pages/stock/UpdateSupplierPage.vue'),
      },
    ],
  },
];
